module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"outOfRangeError":"Der Wert liegt außerhalb des zulässigen Bereichs"},"en":{"outOfRangeError":"The value is out of range"}}')
  delete Component.options._Ctor
}
